import React from 'react';
import PropTypes from 'prop-types';
import CardBase from 'ui-coopeuch-cardbase';
import ButtonBase from 'ui-coopeuch-button';

import Header from '../../organism/Header';
import SpinnerLoader from '../../atoms/SpinnerLoader';

import Candado from '../../../assets/img/candado.svg';
import iconPasswordEyed from '../../../assets/img/icnOjoAbierto.svg';
import iconPasswordEyedClosed from '../../../assets/img/closed-eyed.svg';
import infoIcon from '../../../assets/img/info-icon.svg';


//utils
import { formatRut } from '../../../utils/formatters';
import Contenedor from './styles.js';



const ConfirmacionTemplate = ({
  onChangeHandle,
  onSubmitHandle,
  errorRut,
  errorPassword,
  tipoInput,
  onChangeIconInput,
  onChangeButton,
  rut,
  loading,
  logo
}) => {
  return (
    <Contenedor id="login" className="col-xs col-md-12 col-sm-12 p-0">
      <Header 
         comercioimg={logo}
      />
      <div className="body-webpay-coopeuch">
        {loading ? (
          <SpinnerLoader />
        ):(
          ""
        )}
        <div className="formulario-login-coopeuch">
          <CardBase title="Confirmación de compra">
            <p className="subtitulo-formulario">
              Estimado Socio, para continuar con una compra segura ingresa tu clave de internet Coopeuch.
            </p>

            <form className="formulario-webpay-login">
              <label>
                RUT
                <input type="text" id="rut-login-coopeuch" name="rut" onChange={onChangeHandle} value={formatRut(rut) || ''} disabled />
                <span className="errorGenerico">{errorRut}</span>
              </label>
              <label>
                Ingresa tu clave de internet
                <span className="candado-login"><img src={Candado} alt="img-candado" /></span>
                <input type={tipoInput || ''} id="clave-login-coopeuch" name="clave" onChange={onChangeHandle} maxLength="8" placeholder="Clave alfanumérica" />
                <span className="errorGenerico">{errorPassword}</span>
                <span className="ojo-login" onClick={onChangeIconInput}><img src={tipoInput === "text" ? iconPasswordEyedClosed : iconPasswordEyed} alt="eyed" /></span>
              </label>
              <ButtonBase type="primary" label="Ingresar" onClick={onSubmitHandle} disabled={onChangeButton} />
            </form>
            <div className="contenedor-informacion-login">
              <img src={infoIcon} alt="informacion-login" />
              <p className="strong">
                ¿No recuerdas o no tienes clave de internet?
              </p>
              <p>Llámanos al <strong>600 200 1200</strong></p>
            </div>
          </CardBase>
        </div>
      </div>
    </Contenedor>
  );
};

ConfirmacionTemplate.propTypes = {
  onChangeHandle: PropTypes.func,
  onRememberHandle: PropTypes.func,
  onToggleHandle: PropTypes.func,
  remember: PropTypes.bool,
  rut: PropTypes.string,
  password: PropTypes.string,
  serviceError: PropTypes.object,
  error: PropTypes.object,
  show: PropTypes.bool,
};

ConfirmacionTemplate.defaultProps = {
  onChangeHandle: null,
  onRememberHandle: null,
  onToggleHandle: null,
  remember: false,
  rut: '',
  password: '',
  serviceError: {},
  error: {},
  show: false,
};

export default ConfirmacionTemplate;
